/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Clear_Presets_AriaInputs */



/**
* | output |
* | --- |
* | "Clear all selected presets" |
*
* @param {Batch_Subtitle_Export_Clear_Presets_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_clear_presets_aria = /** @type {((inputs?: Batch_Subtitle_Export_Clear_Presets_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Clear_Presets_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer tous les préréglages sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle ausgewählten Voreinstellungen löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella tutti i preset selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить все выбранные предустановки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar todos los ajustes preestablecidos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除所有选定的预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したプリセットをすべてクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी चयनित प्रीसेट साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar todas as predefinições selecionadas")
	return /** @type {LocalizedString} */ ("Clear all selected presets")
});